module.exports = __webpack_public_path__ + "img/position.e57a9d81.png";